const e = "#0072ce", a = "#1ea7fd", d = "#00335D", c = "#E6F1FA", o = "#eff6ff", n = "#bfdbfe", t = "#2563eb", h = "#f0fdf4", s = "#bbf7d0", S = "#16a34a", f = "#f1f1f1", r = "#a6a6a6", b = "#f9f9f9", l = "#343e49", g = "#636363", y = "#c0c0c0", F = "#8b8b8b", u = "#e7e7e7", w = "#cacaca", C = "#e0e0e0", D = "#505050", k = "#dd0021", i = "#BC001C", E = "#fecaca", p = "#721C24", x = "#FFDDE4", A = "#63000F", B = "#ffffff", j = "#fefeff", m = "#333333", q = "#000000", v = "#1d1d1d", z = "#FFF1C9", G = "#fef08a", H = "#73580D";
export {
  m as blackShade1,
  q as blackShade3,
  v as blackShade4,
  e as blueShade1,
  a as blueShade2,
  d as blueShade3,
  c as blueShade4,
  o as blueShade5,
  n as blueShade6,
  t as blueShade7,
  h as greenShade4,
  s as greenShade5,
  S as greenShade6,
  f as greyShade1,
  u as greyShade10,
  w as greyShade11,
  C as greyShade16,
  D as greyShade18,
  r as greyShade4,
  b as greyShade5,
  l as greyShade6,
  g as greyShade7,
  y as greyShade8,
  F as greyShade9,
  k as redShade1,
  x as redShade10,
  A as redShade11,
  i as redShade5,
  E as redShade7,
  p as redShade9,
  B as whiteShade1,
  j as whiteShade2,
  z as yellowShade2,
  G as yellowShade4,
  H as yellowShade6
};
